const s = {
  name: "Box",
  dimensions: { width: 40, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 30" style="enable-background:new 0 0 40 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,24h7v2h-7V24z"/>
		<path class="st0" d="M31,20h-7v2h7V20z"/>
		<path class="st0" d="M5.3,0L0,12h5v18h30V12h5L34.6,0H5.3z M16,5.7l2.8,6.3H33v16H16V5.7z M33.3,2l3.6,8H20.1l-3.6-8H33.3z
			 M14,5.7V28H7V12h4.2L14,5.7z M6.6,2h6.8l-3.6,8H3.1L6.6,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Box
};
